const About = () => {
  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20"
      >
        <h3 className="font-normal text-black">회사소개</h3>
        <p className="text-secondary my-5 lg:text-lg">- 집치워드림 센터 -</p>
        <p className=" lg:text-lg">
          유품정리 · 특수청소 전문업체 집치워드림 센터
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-6">
        <div className=" relative w-full h-full xl:pl-16">
          <img
            src="images/aboutLeft.png"
            alt="집치워드림센터 대표 및 회사 소개 이미지"
            className=" relative w-full h-full mx-auto"
          />
        </div>
        <div className="relative w-full h-full grid items-center">
          <h3 className="font-normal text-black ">집치워드림 센터는</h3>
          <div className="elative w-full h-full grid gap-2 items-center my-8 lg:my-0">
            <p className="text-sm">
              안녕하세요
              <br />
              고객님과 함께 성장하는 업체 집치워드림 센터입니다.
            </p>
            <p className="text-sm 2xl:text-base">
              집치워드림 센터에서는
              <br />
              <span className="text-secondary">
                유품정리 · 빈집정리 · 이사정리 · 창고정리 · 폐기물처리
              </span>
              와 같은 각종 정리와
              <br />
              <span className="text-secondary">
                고독사청소 · 쓰레기집청소 · 간단한 거주청소
              </span>
              와 같은 특수청소도 진행 가능합니다.
            </p>
            <p className="text-sm">
              필요한 물품과 폐기할 물품을 구분하여 정리해드리며
              <br />
              어떤 현장이라도 정성을 다해 정리해드립니다.
            </p>
            <p className="text-sm 2xl:text-base">
              서울 · 경기 · 인천 · 강원도 (춘천, 원주, 평창, 제천) · 충청도
              (천안, 음성, 청주, 충주) 전지역 어디라도 문의주시면 365일 24시간
              상담이 가능합니다.
            </p>
            <p className="text-sm 2xl:text-base">
              혼자 감당하기 어려운{" "}
              <span className="text-secondary">유품정리 및 특수청소</span>
              <br />
              이젠 혼자 감당하지 마시고 집치워드림 센터와 함께 해결해보세요
            </p>
          </div>
          <div>
            <img
              src="images/logo.png"
              alt="집치워드림센터"
              className="!relative w-auto h-full max-h-16 xl:max-h-20 mx-auto lg:mx-0"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
